import { render, staticRenderFns } from "./ServiceEntitlementTable.vue?vue&type=template&id=b73d8434&"
import script from "./ServiceEntitlementTable.vue?vue&type=script&lang=js&"
export * from "./ServiceEntitlementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports